'use client'
import { TitleDivider } from 'components/TitleDivider'
import { VideoDialog } from 'components/VideoDialog'
import { VideoPlayer } from 'components/VideoPlayer'
import Section from 'components/Section'
import { useMemoizedContentGetter } from '@/utils/contentful'
import { Typography } from 'components/Contentful'
import { StatGrid } from 'components/StatGrid'

const TestimonialSingle = ({ content }) => {
  const { eyebrow, title, grid, backgroundConfig } = useMemoizedContentGetter(content, [
    'eyebrow',
    'title',
    'grid',
    'backgroundConfig',
  ])

  const story = grid.gridItemsCollection.items[0]
  const getAutoplay = () => {
    if (typeof window === 'undefined') return false
    const hash = window.location.hash.slice(1) // Remove the '#' prefix
    if (!hash) return false
    return (story?.config?.id || 'member-story') === hash ? true : false
  }
  return (
    <Section
      className={'flex flex-col px-0 py-12 lg:py-16 lg:px-0'}
      contain={true}
      variant={'achieveHighlightBlue'}
      fullBackground={backgroundConfig?.jsonContent?.fullBackground ?? false}
      id={story?.config?.id || 'member-story'}
      data-testid="testimonial-single"
    >
      {(title || eyebrow) && (
        <TitleDivider
          disableTitleTag={true}
          eyebrow={eyebrow}
          eyebrowBlack
          title={title}
          eyebrowClassName={
            title
              ? 'tracking-[3.5px] leading-[16.8px] pb-2 md:pb-4'
              : 'tracking-[3.5px] leading-[16.8px] pb-[26px]'
          }
          className={eyebrow && !title ? 'mb-0' : ''}
        />
      )}
      <div className="flex lg:flex-row flex-col lg:text-left">
        <>
          <div className="flex justify-center pb-8 w-full">
            <VideoPlayer
              aspectRatio={16 / 9}
              frameClassName={'max-w-[636px] rounded'}
              content={story.videoDialog.videoPlayer}
              capWidth={640}
              extraPadding={200}
              drillPadding={true}
              maxWidth={true}
            />
          </div>
          <div
            className="flex flex-col ml-0 md:ml-6 justify-center lg:text-left text-center"
            data-testid="testimonial-details-wrapper"
          >
            <div
              className={'[&_strong]:font-medium! max-w-[803px] pb-6 flex flex-col text-left'}
              data-testid="testimonial-copy-container"
            >
              <Typography
                content={story?.message}
                className="text-center sm:text-left bodySm lg:bodyLg leading-[140%]"
                data-testid="testimonial-copy"
              />
            </div>
            {story?.statGrid && (
              <div className={'w-full pb-8'} data-testid="testimonial-stat-grid">
                <StatGrid grid={story?.statGrid?.fields} />
              </div>
            )}
            {story?.videoDialog && (
              <div>
                <VideoDialog
                  className="self-start px-0!"
                  capWidth={true}
                  content={story?.videoDialog}
                  trackOpen={{
                    nav_link_section: 'Testimonials',
                  }}
                  autoOpen={getAutoplay()}
                />
              </div>
            )}
            {story?.disclaimer && (
              <Typography
                content={story?.disclaimer}
                variant="bodySm"
                className={'text-center sm:text-left text-[#42546b] max-w-[803px] w-full pt-[24px]'}
                data-testid="testimonial-disclaimer"
              />
            )}
          </div>
        </>
      </div>
    </Section>
  )
}

export { TestimonialSingle }
